import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { Phone, MessageCircle, Mail, MapPin, Clock } from "lucide-react";

export default function ContactPage() {
  const handleCall = () => {
    window.open("tel:+919187501932");
  };

  const handleWhatsApp = () => {
    window.open("https://wa.me/919187501932?text=Hello, I'd like to inquire about Ananya Residency");
  };

  const handleEmail = () => {
    window.open("mailto:ananyaresidencymanipal@gmail.com");
  };

  return (
    <div className="min-h-screen py-16 bg-gradient-to-b from-white to-[#FFF8DC]">
      <div className="container mx-auto px-4">
        {/* Page Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-[#8B6F47] mb-4">
            Contact Us
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Get in touch with us for bookings, inquiries, or any questions about your stay
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {/* Contact Information */}
          <div className="space-y-6">
            <Card className="border-2 border-[#E6D5C3] shadow-md hover:shadow-lg transition-shadow">
              <CardContent className="p-8">
                <h2 className="text-2xl font-serif font-bold text-[#8B6F47] mb-6">
                  Get in Touch
                </h2>

                {/* Address */}
                <div className="flex items-start space-x-4 mb-6 pb-6 border-b border-[#E6D5C3]">
                  <div className="w-12 h-12 bg-[#FFF8DC] rounded-full flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-6 h-6 text-[#8B6F47]" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#8B6F47] mb-2">Address</h3>
                    <p className="text-gray-700 leading-relaxed">
                      Ananya Residency<br />
                      Aniketh Apartment<br />
                      Vidyarathna Nagar<br />
                      V.S Acharya Road<br />
                      Manipal, Udupi
                    </p>
                  </div>
                </div>

                {/* Phone */}
                <div className="flex items-start space-x-4 mb-6 pb-6 border-b border-[#E6D5C3]">
                  <div className="w-12 h-12 bg-[#FFF8DC] rounded-full flex items-center justify-center flex-shrink-0">
                    <Phone className="w-6 h-6 text-[#8B6F47]" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#8B6F47] mb-2">Phone</h3>
                    <a
                      href="tel:+919187501932"
                      className="text-gray-700 hover:text-[#8B6F47] transition-colors"
                    >
                      +91 91875 01932 | +91 8073 474872
                    </a>
                  </div>
                </div>

                {/* Email */}
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#FFF8DC] rounded-full flex items-center justify-center flex-shrink-0">
                    <Mail className="w-6 h-6 text-[#8B6F47]" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#8B6F47] mb-2">Email</h3>
                    <a
                      href="mailto:ananyaresidencymanipal@gmail.com"
                      className="text-gray-700 hover:text-[#8B6F47] transition-colors break-all"
                    >
                      ananyaresidencymanipal@gmail.com
                    </a>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Quick Actions */}
            <Card className="bg-[#8B6F47] text-white border-2 border-[#8B6F47] shadow-md">
              <CardContent className="p-8">
                <h3 className="text-xl font-serif font-bold mb-4">
                  Quick Contact Options
                </h3>
                <div className="space-y-3">
                  <Button
                    onClick={handleCall}
                    className="w-full bg-white text-[#8B6F47] hover:bg-gray-100 justify-start text-lg py-6"
                    size="lg"
                  >
                    <Phone className="w-5 h-5 mr-3" />
                    Call Now
                  </Button>
                  <Button
                    onClick={handleWhatsApp}
                    className="w-full bg-white text-[#8B6F47] hover:bg-gray-100 justify-start text-lg py-6"
                    size="lg"
                  >
                    <MessageCircle className="w-5 h-5 mr-3" />
                    WhatsApp Us
                  </Button>
                  <Button
                    onClick={handleEmail}
                    className="w-full bg-white text-[#8B6F47] hover:bg-gray-100 justify-start text-lg py-6"
                    size="lg"
                  >
                    <Mail className="w-5 h-5 mr-3" />
                    Send Email
                  </Button>
                </div>
              </CardContent>
            </Card>

            {/* Office Hours */}
            <Card className="border-2 border-[#E6D5C3] shadow-md bg-[#FFF8DC]">
              <CardContent className="p-6">
                <div className="flex items-start space-x-3">
                  <Clock className="w-6 h-6 text-[#8B6F47] flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-semibold text-[#8B6F47] mb-2">Available Hours</h3>
                    <p className="text-gray-700 text-sm">
                      We're available 24/7 for inquiries and emergencies. Feel free to call or message us anytime.
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Map */}
          <div>
            <Card className="border-2 border-[#E6D5C3] shadow-md overflow-hidden h-full">
              <CardContent className="p-0 h-full">
                <div className="relative h-full min-h-[600px]">
                  {/* <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3881.91445051119!2d74.7807094750098!3d13.355595406343387!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbca346359ccef9%3A0x608b892a7db5f784!2sAnanya%20Residency!5e0!3m2!1sen!2sin!4v1770823628556!5m2!1sen!2sin"
                    className="w-full h-[450px] rounded-xl shadow-md"
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  /> */}
<iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3881.91445051119!2d74.7807094750098!3d13.355595406343387!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbca346359ccef9%3A0x608b892a7db5f784!2sAnanya%20Residency!5e0!3m2!1sen!2sin!4v1770823628556!5m2!1sen!2sin"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Ananya Residency Location"
                    className="absolute inset-0"
                  ></iframe>
                  {/* Map Overlay */}
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-6">
                    <div className="bg-white/95 backdrop-blur-sm rounded-lg p-4 max-w-md">
                      <h4 className="font-serif font-bold text-[#8B6F47] mb-1">Find Us Here</h4>
                      <p className="text-sm text-gray-600">
                        Vidyarathna Nagar, V.S Acharya Road, Manipal
                      </p>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>

        {/* Bottom Banner */}
        <div className="mt-12 text-center p-8 bg-white rounded-lg shadow-md max-w-3xl mx-auto border-2 border-[#E6D5C3]">
          <h3 className="text-2xl font-serif font-bold text-[#8B6F47] mb-3">
            Visit Us Today
          </h3>
          <p className="text-gray-600 mb-6">
            Come see our comfortable rooms and facilities in person. We'd love to show you around! 
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              size="lg"
              onClick={handleCall}
              className="bg-[#8B6F47] hover:bg-[#6D5838] text-white"
            >
              <Phone className="w-5 h-5 mr-2" />
              Call to Schedule Visit
            </Button>
            <Button
              size="lg"
              onClick={handleWhatsApp}
              variant="outline"
              className="border-2 border-[#8B6F47] text-[#8B6F47] hover:bg-[#8B6F47] hover:text-white"
            >
              <MessageCircle className="w-5 h-5 mr-2" />
              Message Us
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
